import { PLATE_MIDDLE_FT } from 'lib_ts/classes/plate.helper';
import { Vector3 } from 'three';

/** frames per second */
export const FPS = 30.0;

/** width of tracer lines on balls */
export const LINE_WIDTH = 5;

export const SPEEDS = {
  MIN: 1,
  MAX: 10,
};

/** the number after 'pitcher' indicates towards which base on the field */
export type Perspective = 'batter' | 'pitcher-1' | 'pitcher-2' | 'pitcher-3';

export const POV_OPTIONS: Perspective[] = [
  'batter',
  'pitcher-1',
  'pitcher-2',
  'pitcher-3',
];

/** accuracy of the search for final time of each ball */
export const STRIKEZONE_PRECISION = 0.001;
/** distance to the tip of home plate closest to the pitcher */
export const STRIKEZONE_PLATE_DISTANCE_FT = -PLATE_MIDDLE_FT;

export const RPM_TO_RADPS = 0.1047;

/** todo: maybe this belongs somewhere more central */
const getOS = () => {
  const agent = window.navigator.userAgent;

  if (agent.indexOf('Win') !== -1) {
    return 'Windows';
  }

  if (agent.indexOf('Mac') !== -1) {
    return 'MacOS';
  }

  if (agent.indexOf('X11') !== -1) {
    return 'UNIX';
  }

  if (agent.indexOf('Linux') !== -1) {
    return 'Linux';
  }

  return 'Unknown';
};

export const POINT_OFFSETS = (() => {
  const isMacOS = getOS() === 'MacOS';

  if (!isMacOS) {
    return [new Vector3(0, 0, 0)];
  }

  // * MacOS doesn't respect the thickness of the lines, so draw a bunch of them (yeah, wtf)
  const coords = [
    [0, 0, 0],
    [0.01, 0, 0],
    [-0.01, 0, 0],
    [0, 0.01, 0],
    [0, -0.01, 0],
    [0, -0.005, 0],
    [0.015, 0, 0],
    [-0.015, 0, 0],
    [0, 0.015, 0],
    [0, -0.015, 0],
    [0.02, 0, 0],
    [-0.02, 0, 0],
    [0, 0.02, 0],
    [0, -0.02, 0],
    [0.025, 0, 0],
    [-0.025, 0, 0],
    [0, 0.025, 0],
    [0, -0.025, 0],
    [0.03, 0, 0],
    [-0.03, 0, 0],
    [0, 0.03, 0],
    [0, -0.03, 0],
    [0.035, 0, 0],
    [-0.035, 0, 0],
    [0, 0.035, 0],
    [0, -0.035, 0],
  ];

  return coords.map((c) => new Vector3(...c));
})();

export const EYE_LEVEL_FT = 6;

export const BEHIND_MOUND_FT = -70;

export const BEHIND_PLATE_FT = 6;

export const PLATE_LEVEL_FT = 2.2;
